import React, { useEffect, useState } from 'react';
import * as Survey from 'survey-react';
import { get, isNil, isEmpty } from 'lodash';
import { init as DropdownMultiselectWidgetInit } from '../Widgets/DropdownMultiselectWidget';
import { init as DropdownWidgetInit } from '../Widgets/DropdownWidget';
import { init as CalendarWidgetInit } from '../Widgets/CalendarWidget';
import buildResponses from './buildResponses';
import { replaceIdWithUUID } from '../utils';

DropdownMultiselectWidgetInit(Survey);
DropdownWidgetInit(Survey);
CalendarWidgetInit(Survey);

// Override global messages
// console.log(Survey.surveyStrings);
Survey.surveyStrings.invalidExpression = 'Expression is invalid';

// Adding custom property uuid to the question, and each choices
Survey.Serializer.addProperty("question", {
  name: "uuid:string",
  category: "general",
  readOnly: true,
  visible: true
});

Survey.Serializer.addProperty("itemvalue", {
  name: "uuid:string",
  category: "general",
  readOnly: true,
  visible: true
});

export default function SurveyJSFormRenderer({
  formData = {},
  formSubmission,
  editMode,
  handleSetSurveyModel,
}) {
  const [model, setModel] = useState(null);

  useEffect(() => {
    const configuration = formData.configuration;
    if (configuration) {
      // Replace id with uuid
      const json = replaceIdWithUUID(configuration);
      const newModel = new Survey.Model(json);
      newModel.showCompletedPage = false;

      // For test only (when running in localhost the preview tab shows "Complete" button)
      newModel.onComplete.add(function (sender, options) {
        console.log('responses', buildResponses(newModel))
      })

      //If there is a submission data, we need to fill the form with it
      if (!isEmpty(formSubmission)) {
        const data = {};
        formSubmission.responses.forEach((item) => {
          let value = String(!isNil(item.value) ? item.value : '');
          // if value has a comma means it we have multiples values (eg: dropdown-multiselect)
          if (value.indexOf(',') !== -1) {
            value = value.split(',');
          }

          data[item.name] = value;
        });
        newModel.data = data;
      }
      setModel(newModel);
      handleSetSurveyModel(newModel);
    }
  }, [formSubmission]);

  // For readonly mode, show all the question with the answer
  if (!editMode) {
    const questionsNames = get(model, 'questionHashes.names', {});
    const responses = get(formSubmission, 'responses', []);
    const description = get(model, 'description', '');
    return (
      <div className="ui-form-renderer">
        {description && <h5 className="mb-5 normal-case">{description}</h5>}
        {Object.keys(questionsNames).map((questionName) => {
          const questionResponse = responses.find((r) => r.name === questionName);

          let title;
          let displayValue;
          if (questionResponse) {
            ({ title, displayValue } = questionResponse);
          } else {
            const question = model.getQuestionByName(questionName)
            if (question) {
              title = get(question, 'title');

              // For HTML questions, the value is in the html property
              if (question.getType() === 'html') {
                title = get(question, 'html');
              }
            }
          }

          return (
            <div className="ui-form-renderer-question-display" key={title}>
              <div className="ui-form-renderer-question-display__label">{title}</div>
              <div className="ui-form-renderer-question-display__value">{displayValue}</div>
            </div>
          );
        })}
      </div>
    );
  }

  return (model &&
    (
      <Survey.Survey
        model={model}
        showQuestionNumbers="off"
        onUpdateQuestionCssClasses={(survey, options) => {
          // Custom css classes to match Unite Us styles
          const classes = options.cssClasses;
          classes.title += ' ui-form-field__label ui-label-roman ui-label-roman--lowercase';
          if (options.question.getType() === 'text') {
            classes.mainRoot += ' ui-input-field ui-form-field';
          }
          if (options.question.getType() === 'comment') {
            classes.mainRoot += ' ui-text-field ui-form-field';
          }
          if (options.question.getType() === 'radiogroup') {
            classes.mainRoot += ' ui-radio-field ui-form-field';
          }
          if (options.question.getType() === 'checkbox') {
            classes.mainRoot += ' ui-checkbox-group ui-form-field';
            classes.item += ' ui-checkbox-field ui-form-field';
            classes.controlLabel += ' ui-form-field__label';
          }
          if (options.question.getType() === 'dropdown-multiselect' ||
            options.question.getType() === 'dropdown' ||
            (options.question.getType() === 'text' && options.question.inputType === 'date')) {
            classes.mainRoot += ' overflow-visible';
          }
        }}
      />
    )
  );
}
